// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getFeedList = createAsyncThunk(
    'homeFeed/getFeedList',
    async (params) => {

        const response = await axios.get(baseUrl() + '/feed', { params })
        console.log("getFeedList response", response)

        return {
            totalPages: response.data.count.total,
            // params: response.data.params,
            data: response.data.data
        }
    }
)

export const allBusinessList = createAsyncThunk(
    'homeFeed/allBusinessList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/feed', { params })
        return {
            params: response.data.params,
            allBusinessList: response.data.result
        }
    }
)

export const addFeed = createAsyncThunk(
    'homeFeed/addFeed',
    async ({ payload, params }, { dispatch, getState }) => {
        console.log("addFeed", params)

        try {
            await axios.post(baseUrl() + '/feed/add', payload)
            toast.success('Feed Added successfully')
            await dispatch(getFeedList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const updatFeed = createAsyncThunk(
    'homeFeed/updatFeed',
    async ({ id, payload, params }, { dispatch, getState }) => {
        console.log("updatFeed", params)

        try {
            await axios.put(baseUrl() + `/feed/update/${id}`, payload)
            toast.success('Feed Updated successfully')
            await dispatch(getFeedList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const deleteFeed = createAsyncThunk(
    'homeFeed/deleteFeed',
    async ({ id, params }, { dispatch, getState }) => {
        try {
            await axios.delete(baseUrl() + `/feed/${id}`),
                toast.success('Feed Deleted successfully')
            await dispatch(getFeedList(params))
            return true
        } catch (error) {
            toast.error(error?.response?.data?.message)
            return false
        }
    }
)

export const homeFeed = createSlice({
    name: 'homeFeed',
    initialState: {
        feedList: [],
        selectFacility: [],
        allBusinessList: [],
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null,
        clearFilter: false,
        status: '0',
        loading: false,
        params: {
            pageNo: 1,
            pageSize: 10
        },
        rowType: 'row1'


    },
    reducers: {
        selectHomeFeed: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state, action) => {
            state.clearFilter = action.payload
        },
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRowType: (state, action) => {
            state.rowType = action.payload
        }
    },

    extraReducers: {
        [addFeed.fulfilled]: (state, action) => {
            state.reload = !state.reload
        },
        [getFeedList.fulfilled]: (state, action) => {
            state.feedList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },
        [allBusinessList.fulfilled]: (state, action) => {
            state.allBusinessList = action.payload.allBusinessList
        },
        [updatFeed.fulfilled]: (state, action) => {
            state.reload = !state.reload
            state.loader = false
        },
    }
})

export const { selectHomeFeed, selectRowsPerPage, selectCurrentPage, setStatus, setLoader,
    setLoading, selectClearFilter, setRowType } = homeFeed.actions

export default homeFeed.reducer
